module.exports = __webpack_public_path__ + "assets/img/m22-report-img.c3c8e392.png";